import { applyMiddleware, createStore } from "redux";
import logger from "redux-logger";
import createSagaMiddleware from "redux-saga";

import { ConnectState } from "state/ducks/connect/types";
import connectReducer from "state/ducks/connect/reducer";
import connectSaga from "state/ducks/connect/saga";
import navigationReducer from "state/ducks/navigation/reducer";
import navigationSaga from "state/ducks/navigation/saga";
import modelsReducer from "state/ducks/models/reducer";
import modelsSaga from "state/ducks/models/saga";
import tagsReducer from "state/ducks/tags/reducer";
import tagsSaga from "state/ducks/tags/saga";
import favoritesReducer from "state/ducks/favorites/reducer";
import favoritesSaga from "state/ducks/favorites/saga";

import {
  combine,
  reducerRegistry,
  sagaRegistry,
  OAuthSaga,
  OAuthReducer,
} from "coral-utility";

import { composeWithDevTools } from "redux-devtools-extension";
import { NavigationState } from "state/ducks/navigation/types";
import { ModelState } from "state/ducks/models/types";
import { TagState } from "state/ducks/tags/types";
import { FavoriteState } from "state/ducks/favorites/types";

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware, logger];

// Add Reducers
reducerRegistry.register("oauth", OAuthReducer);
reducerRegistry.register("connect", connectReducer);
reducerRegistry.register("navigation", navigationReducer);
reducerRegistry.register("models", modelsReducer);
reducerRegistry.register("tags", tagsReducer);
reducerRegistry.register("favorites", favoritesReducer)

export interface RootState {
  connect: ConnectState;
  navigation: NavigationState;
  models: ModelState;
  tags: TagState;
  favorites: FavoriteState;
}

/** Create Store/Reducers Instances */
const reducer = combine(reducerRegistry.getReducers());

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

/** Setup On Change Listeners */
reducerRegistry.setChangeListener((reducers: any) => {
  store.replaceReducer(combine(reducers));
});

sagaRegistry.setChangeListener((sagas: any) => {
  sagaMiddleware.run(sagas);
});

// Add Sagas
sagaRegistry.register("oauth", OAuthSaga);
sagaRegistry.register("connect", connectSaga);
sagaRegistry.register("navigation", navigationSaga);
sagaRegistry.register("models", modelsSaga);
sagaRegistry.register("tags", tagsSaga);
sagaRegistry.register("favorites", favoritesSaga);

export default store;
